import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ErrorLoginService {

  constructor() { }

  /**
   * Método utilizado para tratamento de erros de login
   * **/
  public errorLoginLib(error: string | null): string {
    switch (error) {
      case "Invalid username or password":
        return "Login e/ou senha incorretos";
      case "Access blocked: your company has been in default.":
        return `
        <div class="blocked-error">
          <b> Acesso ao sistema bloqueado. </b>
          <br>
            Identificamos pendências associadas à sua empresa.
          <br>
          Por favor, entrar em contato para regularização: <br>
          📞<b>
        <a href="https://wa.me/554133431122?text=Ol%C3%A1!%20Estou%20com%20o%20acesso%20ao%20sistema%20bloqueado%20por%20inadimpl%C3%AAncia%20e%20gostaria%20de%20regularizar%20a%20situa%C3%A7%C3%A3o." target="_blank">(41) 3343-1122</a>
        <br>
        Ou
        <br>
        ✉️
        <a href="mailto:financeiro@smartgreen.net" style="text-decoration: none;">financeiro@smartgreen.net</a>
        </div>
        `
      case "Invalid or already used MFA code.":
        return "Código inválido ou já utilizado. Aguarde o próximo código do aplicativo e tente novamente.";
      case "Invalid, expired or already used MFA token.":
        return "A verificação expirou. Informe usuário e senha novamente.";
      case "Too many failed MFA code attempts. Try again later.":
        return "Muitas tentativas incorretas. Aguarde alguns minutos e tente novamente.";
      default:
        return "Erro desconhecido";
    }
  }
}
